export default __webpack_public_path__ + "static/media/applications-image-32.8f8fc8ca.jpg";